import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react';

const ToyScanVideoElement = forwardRef((props, ref: any) => (
  <video
    id="toyScanVideo"
    ref={ref}
    style={{ width: '100%', height: '100%' }}
    muted={true}
    aria-hidden={true}
    playsInline
    data-playlock={`unlocked`}
    {...props}
  />
));

export default ToyScanVideoElement as ForwardRefExoticComponent<
  RefAttributes<HTMLVideoElement>
>;
